module.exports = __webpack_public_path__ + "media/images/countryrect/br-a63ae88a34071291fee04c0e32f64aff.svg";